import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import editIcon from '../../assets/edit.png';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import DetailPoliklinik from './detaiPoli';
import AddSpesialis from './addSpesialis';
import api from '../api';
import filterIcon from '../../assets/ic_search@3x.png';
import Loader from 'react-loader-spinner'

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function Spesialis(props) {
    const [listSpesialis, setListSpesialis] = React.useState([])
    const [detaiSpesialis, setDetailSpesialis] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [visibleDetail, setVisibleDetail] = React.useState(false)
    const [visibleCreate, setVisibleCreate] = React.useState(false)

    React.useEffect(() => {
        getDateSpesialis()
        setLoading(true)
    }, [])

    const handleSeeDetail = (data) => {
        let id = data.rowData[1]
        api.create().getDetailPoli(id).then(response => {
            console.log(response.data.data);
            if (response.data) {
                setDetailSpesialis(response.data.data)
            }
        })
        setVisibleDetail(true)
    }

    const onClose = () => {
        setVisibleDetail(false)
        setVisibleCreate(false)
    }
    const getDateSpesialis = () => {
        api.create().getListSpesialis().then(response => {
            console.log(response)
            if (response.data) {
                let listSpeciality = []
                response.data.data.map((item, index) => {
                    // console.log(item);
                    listSpeciality.push([
                        index + 1,
                        item.id,
                        `Spesialis ${item.name}`,
                        item.status,
                    ])
                })
                setListSpesialis(listSpeciality)
                setLoading(false)
            } else {
                setLoading(false)
            }
        })
    }
    
    const columns = [{
        name: "No",
        options: {
            customHeadRender: (columnMeta) => (
                <TableCell style={{ width: 100 }}>
                    <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ textAlign: 'left'}}>
                        {val}
                    </div>
                )
            }
        }
    }, 
    {
        name: "id",
        label: "ID Spesialis"
    },
    {
        name: "name",
        label: "Nama Spesialis",
    },
    {
        name: "status",
        label: "Status",
    },
    // {
    //     name: "jamBuka",
    //     label: "Jam Buka Poliklinik"
    // },
    // {
    //     name: "jamTutup",
    //     label: "Jam Tutup Poliklinik"
    // },
    {
        name: "Aksi",
        options: {
            customHeadRender: (columnMeta) => (
                <TableCell style={{ width: 300 }}>
                    <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                </TableCell>
            ),
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            style={{
                                backgroundColor: "transparent",
                                fontSize: 20,
                                outline: 'none',
                                borderColor: 'transparent',
                                marginRight: 20
                            }
                            }
                        onClick={() => handleSeeDetail(tableMeta)}
                        >
                            <img src={editIcon} style={{width: 20, height: 20}}/>
                        </button>
                        <button style={{
                            backgroundColor: "transparent",
                            fontSize: 20,
                            outline: 'none',
                            borderColor: 'transparent'
                        }}>
                            <IconSwitch checked={true} />
                        </button>
                    </div>
                )
            }
        }
    }
    ];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 20, }}>
            {loading ? loadingComponent : null}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                // onClick={() => onOpen()}
                >
                    <div onClick={() => setVisibleCreate(true)} style={{ display: 'flex' }}>
                        <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                        <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah Spesialis</Typography>
                    </div>
                </button>
                {/* <div style={{ display: 'flex' }}>
                    <div
                        style={{ height: 32, width: 40, backgroundColor: 'white', borderRadius: 20, marginRight: 10, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }}
                    // onClick={() => handleFilter()}
                    >
                        <img style={{ margin: 'auto', width: 20, marginLeft: 10, marginTop: 5 }} src={filterIcon} />
                    </div>
                    <div style={{ height: 32, width: 170, backgroundColor: 'white', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999' }} />
                </div> */}
            </div>
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={listSpesialis}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            {/* </div> */}
            {
                visibleCreate ?
                    <AddSpesialis
                        onClose={onClose}
                        getData={getDateSpesialis}
                    />
                : null
            }
            {/* {visibleDetail ?
                <DetailPoliklinik
                    onClose={onClose}
                    detail={detailPoli}
                />
                : null} */}
        </div>
    )

}